import styled, { css } from 'styled-components';
import { prop } from 'ramda';

import { media } from '@theme/media';
import { CONTAINER_PADDING, SIDEBAR_WIDTH } from '@components/blocks/blocks.constants';
import { COLORS } from '@theme/colors';
import { FONT_SIZE, typography } from '@theme/font';
import { OFFSET } from '@theme/helpers';

import { textStyles } from '../pdp.styles';

export const Container = styled.div``;

export const OfferedInMobileContainer = styled.div`
  ${media.mobile} {
    display: none;
  }
`;

export const Content = styled.div<{ backgroundColor: COLORS; isSpaceViewMode: boolean }>`
  display: grid;
  grid-template-columns: 100% 0;
  transition: background-color ${({ isSpaceViewMode }) => (isSpaceViewMode ? 0 : 0.6)}s ease-in-out;
  background-color: ${prop('backgroundColor')};

  ${media.tablet} {
    grid-template-columns: calc(100% - ${SIDEBAR_WIDTH}px) ${SIDEBAR_WIDTH}px;
  }
`;

export const ArtworkImagesWrapper = styled.div<{ isSpaceView: boolean }>`
  position: ${({ isSpaceView }) => (isSpaceView ? 'absolute' : 'static')};
  top: 0;
  width: ${({ isSpaceView }) => (isSpaceView ? `calc(100% - ${SIDEBAR_WIDTH}px)` : 'auto')};
`;

export const ArtworkShortDetails = styled.div<{ noPadding?: boolean }>`
  padding: ${({ noPadding }) => !noPadding && '30px 34px'};

  ${media.tablet} {
    display: none;
  }
`;

export const DetailsTitle = styled.h3`
  margin-top: ${OFFSET.M};
  ${textStyles};
`;

export const DetailsDescription = styled.div`
  margin: 0 0 ${OFFSET.S};
  ${textStyles};
`;

export const BulletPoints = styled.div`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Bullet = styled.div`
  position: relative;
  padding-left: 12px;

  &:before {
    content: '\\00B7';
    position: absolute;
    left: 0;
  }
`;

export const MasterEditorial = styled.div`
  ${typography({})};
  height: auto;
  display: flex;
  flex-direction: column;
  padding: calc(${OFFSET.L}) 0;
  position: relative;

  ${media.mobile} {
    ${typography({ size: FONT_SIZE.M })};
  }
`;

export const ArtworkDetailsWrapper = styled.div<{ isSpaceViewMode: boolean }>`
  padding: 0 ${OFFSET.XS} ${OFFSET.XS};
`;

export const MobileDescriptionBlock = styled.div<{ showBackdropFilter: boolean }>`
  display: block;
  position: sticky;
  bottom: 0;
  transition: backdrop-filter 0.5s ease-in-out, background-color 0.5s ease-in-out, transform 200ms ease-in-out;
  z-index: 3;
  ${({ showBackdropFilter }) =>
    showBackdropFilter &&
    css`
      backdrop-filter: blur(24px);
      background: ${COLORS.WHITE40};
      z-index: 4;
    `}

  ${media.tablet} {
    display: none;
  }
`;

export const KlarnaContainer = styled.div`
  display: block;
  padding: 0 ${OFFSET.M};

  ${media.tablet} {
    display: none;
  }
`;
